import React, {Component} from 'react'

class Footer extends Component {

    render(){
        return(
            <footer>
                <div className="container">
                    This is a simple questionnare written in react / redux
                </div>
            </footer>
        )
    }
}

export default Footer



/** WEBPACK FOOTER **
 ** ./src/components/common/Footer.jsx
 **/